import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { getAgents } from '../agentsConfig';
import type { OpenXAgentId } from '../types';

type OpenXAgentSwitcherProps = {
  onAgentSelect: (agentId: OpenXAgentId) => void;
};

export const OpenXAgentSwitcher = ({ onAgentSelect }: OpenXAgentSwitcherProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, px: 0.5 }}>
      <Typography
        sx={{
          fontSize: '12px',
          fontWeight: 'fontWeightMedium',
          lineHeight: '18px',
          textTransform: 'uppercase',
          color: 'text.secondary',
        }}
      >
        {t('Switch to Another Agent')}
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {getAgents(t).map(({ id, name, description }) => (
          <ButtonBase
            key={id}
            onClick={() => onAgentSelect(id)}
            sx={{
              height: 36,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 1.5,
              py: 0.5,
              borderRadius: '4px',
              textAlign: 'left',
              '&:hover': { backgroundColor: 'action.hover' },
            }}
          >
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: 'fontWeightBold',
                  lineHeight: '18px',
                  color: 'text.primary',
                  mb: '-4px',
                }}
              >
                {name}
              </Typography>
              <Typography
                sx={{
                  fontSize: '10px',
                  fontWeight: 'fontWeightRegular',
                  lineHeight: '14px',
                  color: 'text.secondary',
                  display: 'block',
                }}
              >
                {description}
              </Typography>
            </Box>
          </ButtonBase>
        ))}
      </Box>
    </Box>
  );
};
